import StoreInstances, { getStoreFor } from 'Stores/StoreInstances'

import BaseStore from 'Stores/base_store/BaseStore'
import Jobs from 'DataServices/Jobs'
import StoreChangeBus from 'Services/StoreChangeBus'
import { action } from 'mobx'

export const STORE_TYPE = 'Jobs'

export function getJobsStoreFor (param, opts = {}) {
  return getStoreFor(JobsStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

StoreChangeBus.subscribe(evt => {
  if (evt.type === 'Assignments' || evt.type === 'Bids') {
    // Refresh Job if related Assignment or Bid is updated.
    Jobs.getById(evt.data.job_id)
      .then(jobs => StoreInstances._propagateChanges(STORE_TYPE, jobs))
  }
  if (evt.type === 'Events' && evt.data.allow_job_pickup !== evt.previousData.allow_job_pickup) {
    // Update all Jobs on an Event if the `allow_job_pickup` field is changed.
    const store = getJobsStoreFor({ event_id: evt.data.id })
    store.reload()
  }
  if (evt.type === 'Events' && evt.data.assignment_addon_settings !== evt.previousData.assignment_addon_settings) {
    // Update all Jobs on an Event if the `allow_job_pickup` field is changed.
    const store = getJobsStoreFor({ event_id: evt.data.id })
    store.reload()
  }
})

export class JobsStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: true, // (seedData && seedData.filter && seedData.filter.id) ? false : true,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchOne () {
    return Jobs.getById(this._filter.id)
  }

  @action
  _fetchAll (overridePayload) {
    let payload = overridePayload || {
      ...this.filter,
    }

    let getFunc = Jobs.getAll
    if (payload.mode === 'pickups') {
      getFunc = Jobs.getAllPickups
    } else if (payload.mode === 'for_bid') {
      getFunc = Jobs.getAllForBids
    }
    delete payload.mode

    return getFunc(payload)
  }

  @action
  update (job) {
    let payload = {
      ...job,
    }
    return Jobs.update(payload)
      .then(job => {
        StoreInstances._propagateChanges(STORE_TYPE, [job])
        return job
      })
  }

  @action
  create (job) {
    let payload = {
      ...job,
    }
    return Jobs.create(payload)
      .then(job => {
        StoreInstances._propagateChanges(STORE_TYPE, [job])
        return job
      })
  }

  @action
  remove (id) {
    let payload = {
      id: id,
    }
    return Jobs.remove(payload)
      .then(job => {
        StoreInstances._propagateChanges(STORE_TYPE, [job])
        // remove all assignments in related to the job in any Assignments store on the frontend
        StoreInstances._propagateChanges('Assignments', { job_id: job.id }, 'reject')
        return job
      })
  }

  @action
  placeBid (job) {
    return Jobs.placeBid(job.id)
      .then(bid => {
        StoreInstances._propagateChanges('Bids', [bid])
        return bid
      })
  }
}
